import React from 'react';

const MessageBox = ({ variant, ...props }) => {
  return <div className={`alert alert__${variant}`}>{props.children}</div>;
};

export default MessageBox;
